import { EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE, EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_FAIL, EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_SUCCESS, RESET } from "./actionTypes";

const initialState = {
	EmployeeDeductionPlanObject: {},
	DeductionPlanCreateResult: {},
	loading: false,
	error: {
		message: "",
	},
};

const EmployeeCustomDeductionReducer = (state = initialState, action) => {
	if (!action)
		return state;
	switch (action.type) {
		case EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE:
			state = { ...state, DeductionPlanCreateResult: {}, loading: true };
			break;
		case EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_SUCCESS:
			state = { ...state, DeductionPlanCreateResult: action.payload, loading: false };

			break;
		case EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				DeductionPlanCreateResult: {},
				loading: false,
			};
			break;
		case RESET:
			state = { ...state, EmployeeDeductionPlanObject: {}, DeductionPlanCreateResult: {}, loading: false };

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default EmployeeCustomDeductionReducer;